import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { IS_CONDOS, IS_PROPERTY } from 'Config/config'
import SvgIcon from 'Components/SvgIcon'
import {
  _NearbyMapCta, _ImageHolder, _ImageBorder, _Title,
  _Text, _CaptionContainer, _NearbyCtaMobile, _DirectionContainer, _DirectionCaption,
} from './styles'

class NearbyMapCta extends PureComponent {
  onHover() {
    const { googleAnalyticsEvent } = this.props
    googleAnalyticsEvent({
      category: 'listing',
      action: '[Hover over amenity map]',
    })
  }


  render() {
    const { sideBarStyle, handleMapClick, isMapOnlyView, showDirectionCaption } = this.props
    return (
      <_NearbyMapCta
        tabIndex={0}
        data-test-id="nearbyMapCta"
        sideBarStyle={sideBarStyle}
        isMapOnlyView={isMapOnlyView}
        onClick={handleMapClick}
        onMouseEnter={!isMapOnlyView ? this.onHover.bind(this) : () => {}}
      >
        <_ImageBorder isMapOnlyView={isMapOnlyView}>
          <_ImageHolder
            sideBarStyle={sideBarStyle}
            style={{
              backgroundImage: `url(/static/images/amenities-map-${IS_CONDOS ? 'condos' :
                IS_PROPERTY ? 'property' : 'mrloft'}.webp)`,
            }}
            isMapOnlyView={isMapOnlyView}
          />
        </_ImageBorder>
        { isMapOnlyView ?
          <_NearbyCtaMobile>
            See what&apos;s nearby
          </_NearbyCtaMobile>
          :
          <_CaptionContainer>
            <_Title>See what&rsquo;s nearby</_Title>
            <_Text sideBarStyle={sideBarStyle}>
              View grocery, restaurants, bars & more!
            </_Text>
          </_CaptionContainer>
        }
        {showDirectionCaption &&
          <_DirectionContainer>
            <SvgIcon name="#icon-direction" height={21} width={21} />
            <_DirectionCaption>Get Directions</_DirectionCaption>
          </_DirectionContainer>
        }
      </_NearbyMapCta>
    )
  }
}


NearbyMapCta.propTypes = {
  googleAnalyticsEvent: PropTypes.func,
  sideBarStyle: PropTypes.bool,
  handleMapClick: PropTypes.func,
  isMapOnlyView: PropTypes.bool,
  showDirectionCaption: PropTypes.bool,
}
export default NearbyMapCta
